import { ApiComponents } from "@/app/(custom-header)/winners-template/ComponentsMapper";
import React from "react";

export type LayoutRowConfig = {
  layoutType?: LayoutType;
  slots: Partial<Record<LayoutSlot, LayoutItem[]>>;
  spacing?: Spacing;
  background?: Background;
  width?: Width;
  className?: string;
  sectionClassName?: string;
  innerClassName?: string;
  colsClassName?: string;
};

export const isApiComponent = (item: LayoutItem): item is ApiComponents => {
  return typeof item === "object" && "type" in item && "id" in item;
};

export type LayoutItem = ApiComponents | React.ReactNode | null;

export type LayoutType = "full" | "66/33" | "50/50" | "33/66" | "33/33/33" | "25/25/25/25" | "empty";

export type LayoutSlot = "main" | "side" | "col1" | "col2" | "col3" | "col4";

export type Spacing = "none" | "sm" | "md" | "lg" | "xl";

export type Background = "none" | "white" | "gray" | "dark" | "ellipses";

export type Width = "full" | "contained";
